var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containter f-col-w"},[_c('div',{staticClass:"footer-box"},[_c('div',{staticClass:"f10 copy-right"},[_vm._v("\n    版权所有© "+_vm._s(_vm.year)+"\n    "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("*************** ")]),_vm._v("\n    All Rights Reserved.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e740ad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layoutCollege/components/footer.vue
// module id = null
// module chunks = 